import { DataTypeSearchCombo, SearchQuery } from '../Query';
import { isDataTypeSearchCombo } from './isDataTypeSearchCombo';

export const isDataTypeSearchComboArray = (
  arr: (SearchQuery | DataTypeSearchCombo)[],
): arr is DataTypeSearchCombo[] => arr.every(isDataTypeSearchCombo);
